// authService.ts
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onIdTokenChanged,
  User,
  getIdToken,
  sendPasswordResetEmail,
  setPersistence,
  browserLocalPersistence
} from 'firebase/auth'
import { auth } from '../firebaseConfig' // align path with your axios file

const register = (email: string, password: string) =>
  createUserWithEmailAndPassword(auth, email, password)

const login = async (email: string, password: string) => {
  await setPersistence(auth, browserLocalPersistence)
  return signInWithEmailAndPassword(auth, email, password)
}

const logout = () => signOut(auth)

const getToken = async (user: User) => getIdToken(user)

const resetPassword = (email: string) => sendPasswordResetEmail(auth, email)

// Fires on sign-in, sign-out, and silent token refresh
const authStateListener = (callback: (user: User | null) => void) =>
  onIdTokenChanged(auth, user => {
    callback(user)
  })

export { register, login, logout, authStateListener, getToken, resetPassword }
